import { BrowserRouter, Route, Routes } from "react-router-dom";
import RuleApps from "./rules/component/RuleApps";
import Project from "./main/Workspace";
import ItemView from "./main/ItemView";
import MainPage from "./MainPage";
import { AppContext } from "./Contexts";
import AppList from "./rules/AppList";
import GoalList from "./goals/GoalList";
import DashboardList from "./insight/DashboardList";
import DashboardApp from "./insight/DashboardApp";
import ReportsApp from "./insight/ReportsApp";
import DataFields from "./fields/DataFields";
import InboxApp from "./inbox/InboxApp";
import { WorkspaceEmptyState } from "./main/WorkspaceEmptyState";
import UserSetting from "./user/UserSetting";
import PipelineWizard from "./main/PipelineWizard";
import TemplateManager from "./templates/TemplateManager";
import AIContentApp from "./ai-content/AIContentApp";
import TeamSetting from "./team/TeamSetting";
import PipelineSetting from "./pipeline/PipelineSetting";
import ChromeExtension from "./chrome/ChromeExtension";
import { CrmChatController, CrmChatLayoutProvider, CrmChatPage } from "./chat";

export const MainApp = () => {
  const routePrefix = "/workspaces";
  const appContext = { appName: "main", theme: "light", routePrefix };
  return (
    <AppContext.Provider value={appContext}>
      <CrmChatLayoutProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/chrome/:extensionId/:email" element={<ChromeExtension />}></Route>
          <Route
            path="/"
            element={
              <MainPage>
                <PipelineWizard />
              </MainPage>
            }
          ></Route>
          <Route
            path="/workspaces"
            element={
              <MainPage>
                <WorkspaceEmptyState />
              </MainPage>
            }
          ></Route>
          <Route
            path="/workspaces/new"
            element={
              <MainPage>
                <PipelineWizard />
              </MainPage>
            }
          ></Route>
          <Route
            path="/workspaces/:projectId"
            element={
              <MainPage>
                <Project />
              </MainPage>
            }
          ></Route>
          <Route
            path="/workspaces/:projectId/items/:itemId"
            element={
              <MainPage>
                <ItemView />
              </MainPage>
            }
          ></Route>
          <Route
            path="/workspaces/:projectId/ai-content"
            element={
              <MainPage>
                <AIContentApp />
              </MainPage>
            }
          ></Route>
          <Route
            path="/workspaces/:projectId/ai-content/generate"
            element={
              <MainPage>
                <AIContentApp initialView="generate" />
              </MainPage>
            }
          ></Route>
          <Route
            path="/workspaces/:projectId/ai-content/library"
            element={
              <MainPage>
                <AIContentApp initialView="library" />
              </MainPage>
            }
          ></Route>
          <Route
            path="/workspaces/:projectId/ai-content/templates"
            element={
              <MainPage>
                <AIContentApp initialView="templates" />
              </MainPage>
            }
          ></Route>
          <Route
            path="/workspaces/:projectId/reports"
            element={
              <MainPage>
                <DashboardList />
              </MainPage>
            }
          ></Route>
          <Route
            path="/workspaces/:projectId/reports/dashboard/:dashboardId"
            element={
              <MainPage>
                <DashboardApp />
              </MainPage>
            }
          ></Route>
          <Route
            path="/workspaces/:projectId/reports/dashboard/:dashboardId/:reportId"
            element={
              <MainPage>
                <ReportsApp />
              </MainPage>
            }
          ></Route>
          <Route
            path="/workspaces/:projectId/automations"
            element={
              <MainPage>
                <RuleApps />
              </MainPage>
            }
          ></Route>
          <Route
            path="/workspaces/:projectId/automations/:ruleId"
            element={
              <MainPage>
                <RuleApps />
              </MainPage>
            }
          ></Route>
          <Route
            path="/workspaces/:projectId/settings/goals"
            element={
              <MainPage>
                <GoalList />
              </MainPage>
            }
          ></Route>
          <Route
            path="/workspaces/:projectId/settings/goals/:goalId"
            element={
              <MainPage>
                <GoalList />
              </MainPage>
            }
          ></Route>
          <Route
            path="/workspaces/:projectId/settings/apps"
            element={
              <MainPage>
                <AppList />
              </MainPage>
            }
          ></Route>
          <Route
            path="/workspaces/:projectId/settings/data-fields"
            element={
              <MainPage>
                <DataFields />
              </MainPage>
            }
          ></Route>
          <Route
            path="/workspaces/:projectId/settings/pipeline"
            element={
              <MainPage>
                <PipelineSetting />
              </MainPage>
            }
          ></Route>
          <Route
            path="/workspaces/:projectId/settings/team"
            element={
              <MainPage>
                <TeamSetting />
              </MainPage>
            }
          ></Route>
          <Route
            path="/workspaces/:projectId/settings/user"
            element={
              <MainPage>
                <UserSetting />
              </MainPage>
            }
          ></Route>
          <Route
            path="/workspaces/:projectId/templates"
            element={
              <MainPage>
                <TemplateManager />
              </MainPage>
            }
          ></Route>
          <Route
            path="/workspaces/:projectId/inbox"
            element={
              <MainPage>
                <InboxApp />
              </MainPage>
            }
          ></Route>
          <Route
            path="/workspaces/:projectId/ask"
            element={
              <MainPage>
                <CrmChatPage />
              </MainPage>
            }
          ></Route>
        </Routes>
        <CrmChatController />
      </BrowserRouter>
      </CrmChatLayoutProvider>
    </AppContext.Provider>
  );
};
